import LayoutCentered from '@/layout/LayoutCentered';
import Claims from '@/components/pages/claims/Claims';

export default [
  {
    path: '/claims',
    component: LayoutCentered,
    meta: {
      auth: true,
      requirePermission: 'claims',
    },
    children: [
      {
        path: '',
        name: 'ClaimsList',
        component: Claims,
      },
    ],
  },
];
